module.exports = __webpack_public_path__ + "static/media/imatrix.31ed7d40.svg";